import TYPES from '../types'

const initState = {
  userData: '',
  authenticated: false,
  USER_Orders:[],
  tracker:[]
}

const UserState = (state = initState, action) => {
  const { type, data } = action
  switch (type) {
    case TYPES.LOGOUT:
      return { ...initState }
    case TYPES.ALT_AUTH_STATE:
      return {
        ...state,
        authenticated: data,
      }
    case TYPES.ALT_USER_DATA:
      return {
        ...state,
        userData: data,
      }

    case TYPES.USER_Orders:
      return {
        ...state,
        USER_Orders: data,
      }
      case TYPES.tracker:
        return {
          ...state,
          tracker: data,
        }
  
  
    default:
      return state
  }
}

export default UserState
